// Shared per-document AI summary modal (session 96). The extraction pipeline
// persists a plain-English summary onto each uploaded document
// (generic_documents.extractedMetadata.summary). This modal surfaces it wherever a
// document appears — the expandable supporting-docs list, the standalone mount, the
// card-layout document list — so every document's summary is viewable (not just the
// section's most recent). Presentational + controlled; hosts own the open state.

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { FileText } from "lucide-react";

export interface DocumentSummaryTarget {
  filename: string;
  uploadedAt?: string | null;
  summary: string;
}

interface DocumentSummaryModalProps {
  doc: DocumentSummaryTarget | null;
  onOpenChange: (open: boolean) => void;
}

export function DocumentSummaryModal({ doc, onOpenChange }: DocumentSummaryModalProps) {
  return (
    <Dialog open={!!doc} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <FileText className="h-5 w-5 text-primary" />
            Document Summary
          </DialogTitle>
        </DialogHeader>
        {doc && (
          <div className="space-y-3 text-sm">
            <div className="flex items-center justify-between gap-2 text-xs text-muted-foreground border-b pb-2">
              <span className="truncate font-medium text-foreground">{doc.filename}</span>
              {doc.uploadedAt && (
                <span className="shrink-0">{new Date(doc.uploadedAt).toLocaleDateString()}</span>
              )}
            </div>
            <p className="text-foreground leading-relaxed whitespace-pre-wrap">{doc.summary}</p>
            <p className="text-xs text-muted-foreground">
              AI-generated summary — for reference only, may contain errors.
            </p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
